import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, failedResponse } from "../common";
import { getToken } from "../../features/user/UserAvatar";
import { UserInfo } from "./userSlice";

export interface UsersQueryState {
  state: LoadStateInfo;
  filter: string;
  request?: UsersQueryRequest;
  list?: UserInfo[];
}

const initialState: UsersQueryState = {
  state: notStarted(),
  filter: ""
};

export interface UsersQueryRequest {
  filter: string;
}

export const executeUsersQuery = createAsyncThunk(
  "executeUsersQuery",
  async (params: UsersQueryRequest, thunkAPI) => {
    console.debug(`Query users ${params.filter}`);

    const response = await fetch(`${getBackendUrl()}/api/user/query`, {
      method: "POST",
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify(params)
    });

    if(response.ok) {
      return response.json();
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);

export const usersQuerySlice = createSlice({
  name: "executeUsersQuerySlice",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clean: (state) => {
      state.state = notStarted();
      state.request = undefined;
    },
    setFilter: (state, action: PayloadAction<string>) => {
      state.state = notStarted();
      state.filter = action.payload;
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(executeUsersQuery.pending, (state, action) => {
        state.state =  loading();
        state.request = action.meta.arg;
      })
      .addCase(executeUsersQuery.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state =  loaded();
        state.list = action.payload;
        state.list?.sort((a, b) => (a?.name || "").localeCompare(b?.name || ""));
      })
      .addCase(executeUsersQuery.rejected, (state, action) => {
        state.state = error(action);
      });
    },
});

export const { } = usersQuerySlice.actions;

export const selectUsersQuery = (state: RootState) => state.usersQuery;

export default usersQuerySlice.reducer;
